"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'file.clipboard.images_pasted': '已从剪贴板粘贴 {count} 张图片',
};
